<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>工会配置</span>
      </div>

      <el-form>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="图标展示的最小等级">
              <el-input v-model.number="basic.showIconMiniLv" placeholder="公会图标展示的最小等级" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="开放最小等级">
              <el-input v-model.number="basic.openMiniLv" placeholder="公会图标展示的最小等级" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="索要体力数量">
              <el-input v-model.number="basic.askForSpinNum" placeholder="公会图标展示的最小等级" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="索要体力冷却时间">
              <el-input v-model.number="basic.askForSpinCoolingTime" placeholder="公会图标展示的最小等级" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="索要卡片冷却时间">
              <el-input v-model.number="basic.askForCardCoolingTime" placeholder="公会图标展示的最小等级" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="踢出最大人数">
              <el-input v-model.number="basic.removeMaxNum" placeholder="踢出最大人数" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="创建的金币">
              <el-input v-model.number="basic.createWithCoin" placeholder="创建的金币" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="成员最大数量">
              <el-input v-model.number="basic.memberMaxNum" placeholder="成员最大数量" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="帮助体力">
              <el-input v-model.number="basic.helpSpinNum" placeholder="帮助体力" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="加入星星数范围-最小值">
              <el-input v-model.number="basic.joinCfg.miniStar" placeholder="加入星星数范围-最小值" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="加入星星数范围-最大值">
              <el-input v-model.number="basic.joinCfg.maxStar" placeholder="加入星星数范围-最大值" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="每层星星区间值">
              <el-input v-model.number="basic.joinCfg.regulateStar" placeholder="每层星星区间值" />
            </el-form-item>
          </el-col>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="俱乐部创建费用" />
              <commReward v-model="basic.createCost" />
            </el-col>
          </el-row>
        </el-row>
        <el-button type="primary" @click="onSubmit()">保存</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
import commReward from '@/components/Reward/index.vue'

export default {
  name: 'Basic',
  components: {
    commReward
  },
  data() {
    return {
      key: 'CLUB_CONFIG:BASIC',
      basic: {
        maxLevel: 0,
        createCost: [],
        'showIconMiniLv': 3,
        'openMiniLv': 3,
        'askForSpinNum': 10,
        'askForSpinCoolingTime': 600,
        'askForCardCoolingTime': 600,
        'removeMaxNum': 10,
        'createWithCoin': 50000,
        'memberMaxNum': 50,
        'helpSpinNum': 2,
        'club_redpacket': 'ds',
        'joinCfg':
          { 'miniStar': 0, 'maxStar': 9000, 'regulateStar': 200 }
      }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    getTables() {
      getCommonCfg({ name: this.key }).then(res => {
        this.basic = res.data
      })
    },
    onSubmit() {
      const data = JSON.stringify(this.basic)
      updateCommonCfg({ data: data, name: this.key }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
